function ClipboardImage() {
	return (
		<div className='clipboard-image'>
			<svg viewBox='0 0 200 155' xmlns='http://www.w3.org/2000/svg'>
				<path
					className='cls-3'
					d='m 50.20516,21.075967 a 0.62888554,0.62888554 0 0 1 -0.238976,-1.20746 12.74751,12.74751 0 0 1 2.861429,-0.804973 0.63688441,0.63688441 0 0 1 0.201243,1.257771 11.489739,11.489739 0 0 0 -2.572141,0.729507 0.62888554,0.62888554 0 0 1 -0.251555,0.02515 z'
					id='path1'
				/>
				<path
					className='cls-3'
					d='m 42.35038,13.365831 h -0.138355 a 12.477089,12.477089 0 0 0 -2.41492,-0.301865 0.62888554,0.62888554 0 0 1 -0.628886,-0.628886 0.62888554,0.62888554 0 0 1 0.628886,-0.628885 13.741149,13.741149 0 0 1 2.660186,0.333309 0.63267886,0.63267886 0 0 1 -0.138355,1.257771 z'
					id='path2'
				/>
				<path
					className='cls-3'
					d='m 33.294428,14.592158 a 0.62888554,0.62888554 0 0 1 -0.295576,-1.182305 13.659394,13.659394 0 0 1 4.685197,-1.509326 0.63417737,0.63417737 0 1 1 0.163511,1.257771 12.401623,12.401623 0 0 0 -4.257556,1.370971 0.62888554,0.62888554 0 0 1 -0.295576,0.06289 z'
					id='path3'
				/>
				<path
					className='cls-3'
					d='m 31.571282,23.075823 a 0.62888554,0.62888554 0 0 1 -0.452798,-0.194954 8.8609973,8.8609973 0 0 0 -0.874151,-0.798685 0.62888554,0.62888554 0 1 1 0.786107,-0.981061 10.118768,10.118768 0 0 1 0.999928,0.918173 0.62888554,0.62888554 0 0 1 -0.459086,1.056527 z'
					id='path4'
				/>
				<path
					className='cls-3'
					d='m 30.187734,21.893519 a 0.62888554,0.62888554 0 0 1 -0.364754,-0.1132 q -0.270421,-0.188665 -0.553419,-0.364753 a 8.7100647,8.7100647 0 0 0 -3.370827,-1.182305 0.63417737,0.63417737 0 0 1 0.163511,-1.257771 9.961547,9.961547 0 0 1 3.855068,1.352104 q 0.32702,0.194954 0.628885,0.415064 a 0.62888554,0.62888554 0 0 1 -0.358464,1.150861 z'
					id='path5'
				/>
				<path
					className='cls-3'
					d='M 67.468068,29.723144 H 14.76746 V 28.924459 A 10.062169,10.062169 0 0 1 24.779318,18.900023 c 0.245265,0 0.484242,0 0.735796,0 a 15.143564,15.143564 0 0 1 27.922518,0.05031 12.753799,12.753799 0 0 1 13.854349,10.011858 z M 16.025231,28.465373 H 65.883277 A 11.502317,11.502317 0 0 0 53.129478,20.289861 l -0.503108,0.07547 -0.182377,-0.471664 a 13.885793,13.885793 0 0 0 -25.941529,-0.0566 l -0.176088,0.459086 -0.484241,-0.0566 a 8.7477979,8.7477979 0 0 0 -9.816904,8.2384 z'
					id='path6'
				/>
				<path
					className='cls-3'
					d='m 73.241238,29.804899 h -1.37726 a 0.62888554,0.62888554 0 1 1 0,-1.257771 h 1.37726 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
					id='path7'
				/>
				<path
					className='cls-3'
					d='m 68.807595,29.804899 h -54.61871 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 54.61871 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
					id='path8'
				/>
				<path
					className='cls-3'
					d='m 46.412981,23.560065 a 0.62888554,0.62888554 0 0 1 -0.433931,-1.081683 12.778954,12.778954 0 0 1 2.157077,-1.672835 0.62888554,0.62888554 0 0 1 0.66033,1.069105 11.521183,11.521183 0 0 0 -1.943257,1.509325 0.62888554,0.62888554 0 0 1 -0.440219,0.176088 z'
					id='path9'
				/>
				<path
					className='cls-12'
					d='M 198.63,144.87 H 1.37 a 0.37,0.37 0 1 1 0,-0.74 h 197.26 a 0.37,0.37 0 0 1 0,0.74 z'
					id='path172-5'
				/>
				<g id='g40' transform='translate(-22.795192)'>
					<rect
						className='cls-5'
						x='86.464828'
						y='52.054726'
						width='72.045128'
						height='90.836227'
						rx='0.62888557'
						ry='0.62888557'
						id='rect9'
					/>
					<rect
						className='cls-6'
						x='92.728523'
						y='58.324715'
						width='59.517727'
						height='78.308823'
						rx='0.62888557'
						ry='0.62888557'
						id='rect10'
					/>
					<path
						className='cls-7'
						d='M 150.25269,138.4636 H 92.62791 a 1.7294352,1.7294352 0 0 1 -1.72944,-1.72944 V 60.311992 a 1.7294352,1.7294352 0 0 1 1.72944,-1.729435 h 57.63107 a 1.7294352,1.7294352 0 0 1 1.71686,1.729435 v 76.422168 a 1.7294352,1.7294352 0 0 1 -1.72315,1.72944 z M 92.62791,60.154771 a 0.15722138,0.15722138 0 0 0 -0.15722,0.157221 v 76.422168 a 0.15722138,0.15722138 0 0 0 0.15722,0.15722 h 57.63107 a 0.15722138,0.15722138 0 0 0 0.15722,-0.15722 V 60.311992 a 0.15722138,0.15722138 0 0 0 -0.15722,-0.157221 z'
						id='path10'
					/>
					<path
						className='cls-8'
						d='M 157.46601,86.178055 A 0.78610692,0.78610692 0 0 1 156.6799,85.391948 V 54.00427 a 0.11948825,0.11948825 0 0 0 -0.11949,-0.119488 H 92.50842 a 0.786107,0.786107 0 0 1 0,-1.572214 h 64.05199 a 1.6917021,1.6917021 0 0 1 1.70428,1.691702 v 31.387678 a 0.78610692,0.78610692 0 0 1 -0.79868,0.786107 z'
						id='path11'
					/>
					<path
						className='cls-8'
						d='m 156.56041,144.7273 h -17.16229 a 0.78611,0.78611 0 0 1 0,-1.57222 h 17.16858 a 0.11948825,0.11948825 0 0 0 0.11949,-0.11948 v -40.9719 a 0.78610692,0.78610692 0 0 1 1.57221,0 v 40.9719 a 1.6917021,1.6917021 0 0 1 -1.69799,1.6917 z'
						id='path12'
					/>
					<path
						className='cls-8'
						d='M 133.43,144.7273 H 86.32019 a 1.6917021,1.6917021 0 0 1 -1.69171,-1.6917 V 54.00427 a 1.6917021,1.6917021 0 0 1 1.69171,-1.691702 h 1.88665 a 0.786107,0.786107 0 0 1 0,1.572214 H 86.32019 A 0.11948825,0.11948825 0 0 0 86.2007,54.00427 v 89.03133 a 0.11948825,0.11948825 0 0 0 0.11949,0.11948 h 47.10352 a 0.78611,0.78611 0 0 1 0,1.57222 z'
						id='path13'
					/>
					<path
						className='cls-7'
						d='m 124.09734,53.312496 h -7.40198 a 4.3518879,4.3518879 0 0 1 -4.33931,-4.345599 v -0.08804 a 4.3518879,4.3518879 0 0 1 4.3456,-4.345599 h 5.20088 a 1.2577711,1.2577711 0 0 1 0,2.515542 h -5.20717 a 1.8300569,1.8300569 0 0 0 -1.82377,1.830057 v 0.08804 a 1.8300569,1.8300569 0 0 0 1.83006,1.830057 h 7.39569 a 1.8300569,1.8300569 0 0 0 1.83006,-1.830057 v -0.08804 a 1.8237681,1.8237681 0 0 0 -1.14458,-1.697991 1.2583253,1.2583253 0 0 1 0.94333,-2.333165 4.3267325,4.3267325 0 0 1 2.71679,4.031156 v 0.08804 a 4.3518879,4.3518879 0 0 1 -4.3456,4.345599 z'
						id='path14'
					/>
					<path
						className='cls-9'
						d='m 101.66499,49.966825 h 39.5003 a 0.32702048,0.32702048 0 0 1 0.27671,0.503109 c -0.87415,1.37097 -2.88658,5.345527 -0.0377,9.433283 a 0.32702048,0.32702048 0 0 1 -0.26413,0.515686 H 101.7719 a 0.32702048,0.32702048 0 0 1 -0.26413,-0.515686 c 0.91189,-1.257771 2.76081,-4.710353 -0.10691,-9.433283 a 0.32702048,0.32702048 0 0 1 0.26413,-0.503109 z'
						id='path15'
					/>
					<g className='cls-10' id='g16' transform='matrix(0.62888554,0,0,0.62888554,-17.194375,2.8381428)'>
						<path
							className='cls-11'
							d='m 190.27,79.49 h 60.24 c 0,0 -1.56,3.12 0,7.9 h -60.1 a 12.43,12.43 0 0 0 -0.14,-7.9 z'
							id='path16'
						/>
					</g>
					<path
						className='cls-7'
						d='m 140.10877,62.242671 h -5.03109 a 0.786107,0.786107 0 0 1 0,-1.572214 h 4.20725 c -2.10677,-3.660114 -0.83013,-7.169295 0.0692,-8.867286 h -37.93437 c 2.15079,4.056312 1.10055,7.200739 0.15093,8.867286 h 27.8219 a 0.786107,0.786107 0 0 1 0,1.572214 h -28.66461 a 1.1131274,1.1131274 0 0 1 -0.8993,-1.767168 c 0.83013,-1.138283 2.47152,-4.251267 -0.14465,-8.559133 a 1.1131274,1.1131274 0 0 1 0.94962,-1.691702 h 39.5003 a 1.1131274,1.1131274 0 0 1 0.93704,1.710569 c -0.86786,1.358393 -2.60359,4.905307 -0.0566,8.552843 a 1.1131274,1.1131274 0 0 1 -0.91188,1.748302 z'
						id='path17'
					/>
					<path
						className='cls-7'
						d='M 123.85207,69.915074 H 97.5961 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 26.25597 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path18'
					/>
					<path
						className='cls-7'
						d='M 110.62661,82.826095 H 97.5961 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 13.03051 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path19'
					/>
					<path
						className='cls-7'
						d='m 130.18495,82.826095 h -13.20659 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 13.20659 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path20'
					/>
					<path
						className='cls-7'
						d='M 120.40578,76.373729 H 97.5961 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 22.80968 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path21'
					/>
					<path
						className='cls-7'
						d='m 145.37883,76.373729 h -18.93575 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 18.92946 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path22'
					/>
					<path
						className='cls-7'
						d='m 133.43,98.491633 h -25.43213 a 0.62888554,0.62888554 0 0 1 0,-1.257771 H 133.43 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path23'
					/>
					<path
						className='cls-7'
						d='M 139.59308,98.491633 H 138.285 a 0.62888554,0.62888554 0 0 1 0,-1.257771 h 1.30808 a 0.62888554,0.62888554 0 0 1 0,1.257771 z'
						id='path24'
					/>
					<path
						className='cls-7'
						d='m 102.44481,100.64871 h -4.59715 a 0.79868464,0.79868464 0 0 1 -0.79869,-0.798684 v -4.565709 a 0.79868464,0.79868464 0 0 1 0.79869,-0.798684 h 3.02494 a 0.47166415,0.47166415 0 0 1 0,0.943328 h -2.8803 v 4.257555 h 4.30158 v -2.962051 a 0.471665,0.471665 0 0 1 0.94333,0 v 3.106695 a 0.79868464,0.79868464 0 0 1 -0.7924,0.81755 z'
						id='path25'
					/>
					<path
						className='cls-7'
						d='M 100.01731,99.453828 98.08663,96.74962 a 0.47166415,0.47166415 0 1 1 0.76724,-0.54713 l 1.15715,1.616236 3.93683,-5.622237 a 0.47192656,0.47192656 0 1 1 0.77353,0.540842 z'
						id='path26'
					/>
					<path
						className='cls-7'
						d='m 102.29388,126.68457 h -4.23869 a 0.97477259,0.97477259 0 0 1 -0.97477,-0.97477 v -4.23869 a 0.97477259,0.97477259 0 0 1 0.97477,-0.97477 h 4.23869 a 0.97477259,0.97477259 0 0 1 0.97477,0.97477 v 4.23869 a 0.97477259,0.97477259 0 0 1 -0.97477,0.97477 z m -4.23869,-5.2449 v 4.27013 l 4.27013,0.0314 a 0.03144428,0.03144428 0 0 0 0.0314,-0.0314 v -4.23869 z'
						id='path27'
					/>
					<path
						className='cls-7'
						d='m 102.29388,118.00595 h -4.23869 a 0.97477259,0.97477259 0 0 1 -0.97477,-0.97477 v -4.23869 a 0.97477259,0.97477259 0 0 1 0.97477,-0.97477 h 4.23869 a 0.97477259,0.97477259 0 0 1 0.97477,0.97477 v 4.23869 a 0.97477259,0.97477259 0 0 1 -0.97477,0.97477 z m -4.23869,-5.2449 v 4.27013 l 4.27013,0.0314 a 0.03144428,0.03144428 0 0 0 0.0314,-0.0314 v -4.23869 z'
						id='path28'
					/>
					<path
						className='cls-7'
						d='m 102.29388,109.32733 h -4.23869 a 0.97477259,0.97477259 0 0 1 -0.97477,-0.97477 v -4.26385 a 0.97477259,0.97477259 0 0 1 0.97477,-0.97477 h 4.23869 a 0.97477259,0.97477259 0 0 1 0.97477,0.97477 v 4.23869 a 0.97477259,0.97477259 0 0 1 -0.97477,0.99993 z m -4.26385,-5.23862 v 4.27014 h 4.27014 a 0.03144428,0.03144428 0 0 0 0.0314,0 v -4.27014 z'
						id='path29'
					/>
					<path
						className='cls-7'
						d='m 139.59308,123.82314 h -31.59521 a 0.62888554,0.62888554 0 0 1 0,-1.25777 h 31.59521 a 0.62888554,0.62888554 0 0 1 0,1.25777 z'
						id='path30'
					/>
					<path
						className='cls-7'
						d='m 139.59308,115.40865 h -31.59521 a 0.62888554,0.62888554 0 0 1 0,-1.25777 h 31.59521 a 0.62888554,0.62888554 0 0 1 0,1.25777 z'
						id='path31'
					/>
					<path
						className='cls-7'
						d='m 139.59308,106.93757 h -31.59521 a 0.62888554,0.62888554 0 0 1 0,-1.25777 h 31.59521 a 0.62888554,0.62888554 0 0 1 0,1.25777 z'
						id='path32'
					/>
					<rect
						className='cls-12'
						x='170.82532'
						y='-44.250179'
						width='7.4019833'
						height='39.28648'
						transform='rotate(46.72)'
						id='rect32'
					/>
					<path
						className='cls-13'
						d='m 158.36782,90.609815 v 0 a 3.697847,3.697847 0 0 1 -0.15696,5.227189 l -3.80462,3.582785 -5.08316,-5.397889 3.80462,-3.582786 a 3.697847,3.697847 0 0 1 5.22719,0.156966 z'
						id='path33'
					/>
					<polygon
						className='cls-11'
						points='211.13,201.36 219.3,187.82 227.37,196.38 213.36,203.72 '
						id='polygon33'
						transform='matrix(0.62888554,0,0,0.62888554,-17.194375,2.8381428)'
					/>
					<polygon
						className='cls-7'
						points='208.94,205.59 211.18,201.41 213.31,203.68 209,205.66 '
						id='polygon34'
						transform='matrix(0.62888554,0,0,0.62888554,-17.194375,2.8381428)'
					/>
					<path
						className='cls-11'
						d='m 158.35273,90.59912 v 0 a 3.697847,3.697847 0 0 1 0.62889,0.905595 l 1.62253,-1.528192 a 1.087972,1.087972 0 1 0 -1.49046,-1.584791 l -1.62253,1.528192 a 3.697847,3.697847 0 0 1 0.86157,0.679196 z'
						id='path34'
					/>
					<path
						className='cls-11'
						d='m 159.64824,93.724681 -0.10062,-0.106911 -0.0503,0.07547 a 3.6852693,3.6852693 0 0 1 -1.13829,2.30801 l -1.59108,1.496747 -0.15093,0.207533 a 0.91188403,0.91188403 0 0 1 -0.0377,1.257771 l -8.32645,7.842199 a 0.62888554,0.62888554 0 0 0 -0.92446,0 l -0.68548,0.62889 a 0.62888554,0.62888554 0 0 0 0,0.92446 l -0.99364,0.93704 a 0.65177699,0.65177699 0 0 0 0.89301,0.94961 l 12.9802,-12.231817 a 3.0375172,3.0375172 0 0 0 0.12578,-4.288999 z'
						id='path35'
					/>
					<path
						className='cls-7'
						d='m 125.00293,127.82914 -6.1505,-6.53412 29.74629,-28.010559 6.1505,6.534121 z m -3.93053,-6.46494 3.99342,4.24498 27.45715,-25.853487 -3.99343,-4.244977 z'
						id='path36'
					/>
					<path
						className='cls-7'
						d='m 153.60465,100.90027 -6.1505,-6.534126 4.4022,-4.1192 a 4.4867414,4.4867414 0 0 1 6.1505,6.534121 z m -3.93054,-6.464948 3.99343,4.244977 3.23247,-3.043806 a 2.914072,2.914072 0 1 0 -3.99342,-4.244977 z'
						id='path37'
					/>
					<path
						className='cls-7'
						d='m 116.06647,132.30681 -2.21996,-2.35832 5.9807,-9.91124 6.49638,6.91774 z m -0.25784,-2.56585 0.58486,0.62888 7.36425,-3.85507 -3.65382,-3.88022 z'
						id='path38'
					/>
					<polygon
						className='cls-7'
						points='206.22,206.4 209.7,199.88 214.22,204.68 207.51,207.77 '
						id='polygon38'
						transform='matrix(0.62888554,0,0,0.62888554,-17.194375,2.8381428)'
					/>
					<path
						className='cls-7'
						d='m 157.98798,93.183839 -0.47166,-0.955906 a 2.9180289,2.9180289 0 0 0 -1.17602,-1.257771 l -0.92446,-0.528263 2.39605,-2.2577 a 1.8866566,1.8866566 0 0 1 2.57215,2.729364 z m -0.0314,-2.955762 0.21382,0.213822 0.20124,0.226398 0.94333,-0.886728 a 0.30251944,0.30251944 0 0 0 -0.41506,-0.44022 z'
						id='path39'
					/>
					<path
						className='cls-7'
						d='m 145.32223,111.59761 h -0.044 a 1.4401479,1.4401479 0 0 1 -0.94332,-2.51554 l 0.59115,-0.55971 a 1.4527256,1.4527256 0 0 1 0,-0.29558 1.4275702,1.4275702 0 0 1 0.4528,-1.00622 l 0.68548,-0.62888 a 1.4401479,1.4401479 0 0 1 1.32695,-0.35218 l 7.92396,-7.458579 a 0.12577711,0.12577711 0 0 0 0,-0.176088 l -0.44651,-0.471664 0.62888,-0.848996 1.59109,-1.496747 a 2.9117401,2.9117401 0 0 0 0.8993,-1.81748 v -0.207532 l 0.72951,-1.018794 0.75466,0.804973 a 3.8236241,3.8236241 0 0 1 -0.16351,5.402127 L 146.3159,111.2077 a 1.4275702,1.4275702 0 0 1 -0.99364,0.38991 z m 1.20746,-3.29536 0.26413,0.283 0.49053,-0.45909 -0.26413,-0.283 z m 10.28856,-10.106193 a 1.7105687,1.7105687 0 0 1 0,0.924462 l 1.38355,-1.301793 a 2.2451214,2.2451214 0 0 0 0.69807,-1.848924 4.477665,4.477665 0 0 1 -0.78611,0.981062 z'
						id='path40'
					/>
				</g>
			</svg>
		</div>
	);
}

export { ClipboardImage };
